import type { OpUnitType } from "dayjs";
import dateTimeService from "app/services/date-time/dateTimeService";
import { GranularityNames, granularityNameToMomentUnit } from "app/UtilitiesAndConstants/Constants/Moment";
import type { RawDate } from "app/UtilitiesAndConstants/types/dates";
import { isEndOfPeriod } from "app/UtilitiesAndConstants/UtilityFunctions/timeAndDate";

const MONTH_OF_YEAR = 12;

export const isPartialGraphDataAvailable = (
    date: RawDate,
    timeGranularity: string,
    lastSupportedDate: RawDate,
    index?: number,
): boolean => {
    const utcDate = dateTimeService.getUTCMoment(date);
    const utcLastSupportedDate = dateTimeService.getUTCMoment(lastSupportedDate);

    if (index && index > MONTH_OF_YEAR) {
        return utcDate
            .add(1, granularityNameToMomentUnit[timeGranularity as GranularityNames] as OpUnitType)
            .add(1, "year")
            .subtract(1, "days")
            .isAfter(utcLastSupportedDate);
    }

    return utcDate
        .add(1, granularityNameToMomentUnit[timeGranularity as GranularityNames] as OpUnitType)
        .subtract(1, "days")
        .isAfter(utcLastSupportedDate);
};

export const isPartialDataPoint = (
    pointDate: RawDate,
    timeGranularity: string,
    lastSupportedDate: RawDate,
    index?: number,
): boolean => {
    if (timeGranularity === GranularityNames.DAILY) {
        return false;
    }

    const isPointOutOfAvailableRange = isPartialGraphDataAvailable(
        pointDate,
        timeGranularity,
        lastSupportedDate,
        index,
    );

    return timeGranularity === GranularityNames.MONTHLY
        ? isPointOutOfAvailableRange && !isEndOfPeriod(pointDate, "month")
        : isPointOutOfAvailableRange;
};
